const SELECTORS = {
  tile: '.js-tile',
  description: '.js-tile-description',
};

const CLASSES = {
  open: 'is-open',
};

const toggleBreakpoint = 1024;

class Tile {
  constructor(tile) {
    this.tile = tile;
    this.descriptionContent = this.tile.querySelector(SELECTORS.description);

    this.hoverListeners();
  }

  get descriptionHeight() {
    return this.descriptionContent.offsetHeight;
  }

  hoverListeners() {
    this.tile.addEventListener('mouseenter', this.enterHandler.bind(this));
    this.tile.addEventListener('mouseleave', this.leaveHandler.bind(this));
  }

  leaveHandler() {
    this.tile.classList.remove(CLASSES.open);
  }

  enterHandler() {
    if (
      this.descriptionContent &&
      window.matchMedia(`(min-width: ${toggleBreakpoint}px)`).matches
    ) {
      // Prevent updating height on mobile - content should remain hidden
      this.tile.style.setProperty(
        '--desc-height',
        `${this.descriptionHeight}px`,
      );
    }

    requestAnimationFrame(() => {
      this.tile.classList.add(CLASSES.open);
    });
  }
}

export default () => {
  Array.from(document.querySelectorAll(SELECTORS.tile)).forEach(
    (tile) => new Tile(tile),
  );
};
